/**
 * Funnel API client + localStorage persistence for the free-trial flow.
 */
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
const STORAGE_KEY = 'athlopeak_funnel_state_v1';

const funnelApi = {
  startSession: async () => {
    const { data } = await axios.post(`${API}/api/funnel/start`);
    return data.session_id;
  },
  getEquipment: async () => {
    const { data } = await axios.get(`${API}/api/funnel/equipment`);
    return data.equipment;
  },
  generate: async (sessionId, answers) => {
    const { data } = await axios.post(`${API}/api/funnel/generate`, {
      session_id: sessionId,
      answers,
    });
    return data;
  },
  status: async (planId) => {
    const { data } = await axios.get(`${API}/api/funnel/status/${planId}`);
    return data;
  },
  claim: async (planId, email) => {
    const { data } = await axios.post(`${API}/api/funnel/claim`, {
      plan_id: planId,
      email,
    });
    return data;
  },
  emailPlan: async (planId, email) => {
    const { data } = await axios.post(`${API}/api/funnel/email-plan`, {
      plan_id: planId,
      email,
      consent: true,
    });
    return data;
  },
};

export const funnelStorage = {
  save: (state) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch {
      /* quota or private mode — silently ignore */
    }
  },
  load: () => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  },
  clear: () => {
    try {
      localStorage.removeItem(STORAGE_KEY);
    } catch { /* ignore */ }
  },
};

export default funnelApi;
